import React, {FC, useMemo} from 'react';
import {Flex, Icon, PriorityIcon, Text, Title} from '@priority-software/priority-style-react';
import styles from './SideBar.module.scss';
import {WizardStepCommon, WizardStepEnum} from '../../types';
import classNames from 'classnames';
import {useSideBarContext} from '../../hooks';
import texts from '../../texts';

const getStepClassname = (
    step: WizardStepCommon,
    currentStep: WizardStepCommon,
    steps: WizardStepCommon[]
): string => {
    const currentStepIndex = steps.findIndex(x => x === currentStep);
    const stepIndex = steps.findIndex(x => x === step);

    return currentStepIndex > stepIndex
        ? styles.finishedStep
        : currentStepIndex === stepIndex
        ? styles.currentStep
        : styles.futureStep;
};

export const SideBar: FC = () => {
    const sideBarContext = useSideBarContext();

    const steps = useMemo(
        () =>
            sideBarContext.stageStepsMapping[sideBarContext.currentStageIndex].steps.filter(
                x => x.type !== WizardStepEnum.Welcome
            ),
        [sideBarContext]
    );

    return (
        <Flex
            direction={'column'}
            componentClasses={styles.wrapper}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
        >
            <Title skin={'h4'} textColor={'primary-700'}>
                {texts[sideBarContext.stageStepsMapping[sideBarContext.currentStageIndex].name]}
            </Title>
            <Flex direction={'column'} componentClasses={styles.stepsWrapper}>
                {steps
                    .filter(x => x.type !== WizardStepEnum.Finished)
                    .map((x, index) => (
                        <div
                            key={index}
                            className={classNames(
                                styles.step,
                                getStepClassname(
                                    x as WizardStepCommon,
                                    sideBarContext.currentStep as WizardStepCommon,
                                    steps as WizardStepCommon[]
                                )
                            )}
                        >
                            <Text tag={'span'} skin={'paragraph-1'}>
                                {texts[(x as WizardStepCommon)?.nameShort] || texts[x.name]}
                            </Text>
                            <Icon componentClasses={styles.icon} icon={PriorityIcon.check} />
                        </div>
                    ))}
            </Flex>
        </Flex>
    );
};
